<template>
	<Modal
		v-if="showModal"
		:allow-close="true"
		:max-width="'max-w-[691px]'"
		:hide-actions="true"
		:prevent-scrolling="false"
		@modal:close="closeModal"
	>
		<template #body>
			<div class="px-8 pb-[44px] font-Inter">
				<div>
					<div class="flex justify-center">
						<SuccessIllustration v-if="success" /> 
						<FailedIcon v-else />
					</div>

					<div class="mt-7 text-center">
						<h2 class="text-[24px] leading-[34px] font-semibold text-won-blue">
							<span v-if="success">Success! Your resume is uploaded.</span>
							<span v-else>Failed to upload your resume</span>
						</h2>

						<p class="mt-3 text-center text-base text-won-dark-blue">
							<span v-if="success">
								Your resume has been formatted to Wonsulting's template. Please note for best results, you may need to fine-tune some details
							</span>
							<span v-else>There was an error uploading your resume, please try with another file.</span>
						</p>
					</div>

					<button
						v-if="success"
						class="mt-9 w-full rounded border-won-green bg-won-green py-[9.5px] text-white"
						@click="emit('view-resume')"
					>
						View Resume<span v-if="keepOriginalFormat">s</span>
					</button>

					<button
						v-else
						class="mt-9 w-full rounded border-won-green bg-won-green py-[9.5px] text-white"
						@click="closeModal()"
					>
						Close
					</button>
				</div>
			</div>
		</template>
	</Modal>
</template>
  
<script setup>
import Modal from '../../components/modal';

import SuccessIllustration from '../../icons/success-apply.vue';
import FailedIcon from '../../icons/failed-application-icon.vue';

const emit = defineEmits(['view-resume']);
defineProps({
	showModal: {
		type: Boolean,
		default: false,
	},
	closeModal: {
		type: Function,
		required: true
	},
	success: {
		type: Boolean,
		default: true
	},
	keepOriginalFormat: {
		type: Boolean,
		default: true
	}
});
</script>
